import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {DataARPaymentListModel} from '../../models/data-ar-payment-list.model';
import {DataArLedgerItemProcedureAdjustments} from '../../models/data-ar-ledger-item-procedure-adjustments';
import {EnumARPaymentType} from '../../../../models/enum/enum-ar-payment-type';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { InsuranceChangeDialogComponent } from '../../../../dialog/insurance-change-dialog/insurance-change-dialog.component';
import { Globals } from '../../../../globals';
import { ArPaymentDetailsComponent } from '../../payment/ar-payment-details/ar-payment-details.component';
import { UiService } from 'src/app/services/ui.service';

@Component({
  standalone: false,
  selector: 'app-ar-ledger-procedure-details',
  templateUrl: './ar-ledger-procedure-details.component.html',
  styleUrls: ['./ar-ledger-procedure-details.component.scss']
})
export class ArLedgerProcedureDetailsComponent implements OnInit {

  isLoading: boolean = false;
  ledgerItem: DataARLedgerListModel;
  ledgerItems: DataARLedgerListModel[] = [];
  allLedgerItems: DataARLedgerListModel[] = [];
  distributions: DataARPaymentListModel[] = [];
  distributionsPatient: DataARPaymentListModel[] = [];
  distributionsInsurance: DataARPaymentListModel[] = [];
  adjustmentsPatient: DataArLedgerItemProcedureAdjustments[] = [];
  adjustmentsInsurance: DataArLedgerItemProcedureAdjustments[] = [];

  enumLedgerItemTypeClaimCreated: string = '00000078-1000-0000-0000-000000000009';
  enumLedgerItemTypeCreditPayment: string = '00000078-1000-0000-0000-000000000004';
  enumLedgerItemTypeCreditAdjustment: string = '00000078-1000-0000-0000-000000000007';
  enumLedgerItemTypeCreditAdjustmentInsurance: string = '00000078-1000-0000-0000-000000000008';
  enumLedgerItemTypeDebitAdjustment: string = '00000078-1000-0000-0000-000000000006';
  enumLedgerItemTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumLedgerItemTypeDebit: string = '00000078-1000-0000-0000-000000000002';
  enumLedgerItemTypeRefund: string = '00000078-1000-0000-0000-000000000005';
  enumLedgerItemTypeWriteOff: string = '00000078-1000-0000-0000-000000000003';
  //enumLedgerItemTypeDebitPatientPay: string = '00000078-1000-0000-0000-000000000012';

  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';

  enumARDistribItemStatusVoid: string = '00000535-1000-0000-0000-000000000002';

  constructor(
    public dialogRef: MatDialogRef<ArLedgerProcedureDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly arService: ARService,
    private readonly dialog: MatDialog,
    private readonly globals: Globals,
    private readonly cdr: ChangeDetectorRef,
    private readonly uiService: UiService
  ) { }

  ngOnInit(): void {
    console.log('ArLedgerProcedureDetailsComponent ngOnInit', this.data);
    this.ledgerItem = this.data.dataLedgerItem;
    this.ledgerItems = this.data.dataLedgerItems;
    this.allLedgerItems = this.data.allDataLedgerItems;
    this.init();
  }

  async init() {
    const promises: any[] = [
      this.getPaymentDistributionsList(), // get credits too?? debits??
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.distributions = results[0];
      //console.log('ArLedgerProcedureDetailsComponent distributions:', this.distributions);

      this.distributionsPatient = this.distributions.filter(a => (a.enumPaymentSourceID === PAYMENT_SOURCE.Patient 
          || a.enumPaymentSourceID === PAYMENT_SOURCE.ApplyCredit) 
          || (a.PaymentDistributionTypeName?.toUpperCase() === 'WRITE OFF' && a.enumPaymentSourceID != PAYMENT_SOURCE.Insurance));
      // console.log('ArLedgerProcedureDetailsComponent distributionsPatient:', this.distributionsPatient);

      this.distributionsInsurance = this.distributions.filter(a => a.enumPaymentSourceID === PAYMENT_SOURCE.Insurance);
      // console.log('ArLedgerProcedureDetailsComponent distributionsInsurance:', this.distributionsInsurance);
      // build adjustments lists
      this.distributionsInsurance.forEach(a => {
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.PaymentAmount;
        adj.debitCredit = 'credit';
        adj.Date = ConversionUtilities.convertUTCDateToLocalDateFromString(a.PaymentDistributionDate);
        adj.Type = a.PaymentDistributionTypeName;
        adj.PaymentSource = this.returnPaymentType(a.enumARPayementTypeID);
        adj.PaymentDistributionStatus = a.PaymentDistributionStatus;
        adj.PaymentDistributionTypeName = a.PaymentDistributionTypeName;
        adj.PaymetnID = a.PaymetnID;
        adj.PatientId = a.PatientId;
        adj.LedgerID = a.LedgerID;
        adj.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeInsurance;

        if (a.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
          adj.PaymentSource = 'VOID - ' + adj.PaymentSource;
        }
        else if (adj.Type?.toUpperCase().includes('WRITE')) {
          adj.PaymentSource = a.PaymentDistributionTypeName;
        }
        adj.hasPaymentDetails = this.allLedgerItems.some(i => i.PaymetnID === a.PaymetnID && i.enumARPayementTypeID !== null);
        this.adjustmentsInsurance.push(adj);
      });

      this.distributionsPatient.forEach(a => {
        // console.log('distributionsPatient:', a);
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.PaymentAmount;
        adj.debitCredit = 'credit';
        adj.Date = a.PaymentDistributionDate;
        adj.Type = a.PaymentDistributionTypeName;
        adj.PaymentSource = this.returnPaymentType(a.enumARPayementTypeID);
        adj.PaymentDistributionStatus = a.PaymentDistributionStatus;
        adj.PaymentDistributionTypeName = a.PaymentDistributionTypeName;
        adj.PaymetnID = a.PaymetnID;
        adj.PatientId = a.PatientId;
        adj.LedgerID = a.LedgerID;
        adj.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
        adj.hasPaymentDetails = this.allLedgerItems.some(i => i.PaymetnID === a.PaymetnID && i.enumARPayementTypeID !== null);
        if (a.enumPaymentSourceID === PAYMENT_SOURCE.ApplyCredit) {
          adj.PaymentSource = 'Patient Credit';
        }

        if (a.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
          adj.PaymentSource = 'VOID - ' + adj.PaymentSource;
        }

        this.adjustmentsPatient.push(adj);
      });

      this.ledgerItems = this.ledgerItems.filter(a => a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay);
      this.ledgerItems.forEach(a => {
        // console.log('ledgerItem DebitPatientPay:', a);
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.Amount;
        adj.debitCredit = a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay ? 'debit' : '';
        adj.Date = a.PostDate;
        adj.PaymentDistributionStatus = a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void ? this.enumARDistribItemStatusVoid : '';
        adj.PatientId = a.PatientId;
        adj.LedgerID = a.LedgerID;

        if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay) { 
          adj.PaymentSource = 'Patient Responsibility'; 
          adj.PaymentDistributionTypeName = 'Insurance Short Pay';
        }
        else { adj.PaymentSource = ''; }

        if (a.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient) {
          this.adjustmentsPatient.push(adj);
        }
      });

      this.addDebitAdjustments();

      this.isLoading = false;
      this.cdr.detectChanges();
    }
    catch (err) {
      console.log(err);
      this.createMessage('Something went wrong getting Procedure details', 'Error');
      this.isLoading = false;
    }
  }

  // Debit adjustments are standalone ledger rows (no payment distribution), so get-payments-for-ledger-transaction
  // doesn't return them; ledger-created ones are linked to the charge only through ParentLedgerID.
  // The parent link is authoritative (the same ARTransactionItemID can belong to several charge rows after a
  // claim is voided/recreated); ARTransactionItemID is only a fallback for adjustments without a parent.
  addDebitAdjustments() {
    const debitAdjustments = (this.allLedgerItems || []).filter(a => {
      if (a.enumARLedgerItemTypeID !== LEDGER_ITEM_TYPE.DebitAdjustment) { return false; }
      // OriginalParentLedgerID is the DB ParentLedgerID exposed by getLedgerForPatient2; ParentLedgerID is the
      // wire-contract fallback (debit adjustment rows are never rewritten - only charge rows are)
      const parentLedgerID = a.OriginalParentLedgerID || a.ParentLedgerID;
      return parentLedgerID
        ? parentLedgerID === this.ledgerItem.LedgerID
        : !!a.ARTransactionItemID && a.ARTransactionItemID === this.ledgerItem.ARTransactionItemID;
    });

    const seenLedgerIDs = new Set<string>();
    debitAdjustments.forEach(a => {
      if (seenLedgerIDs.has(a.LedgerID)) { return; }
      seenLedgerIDs.add(a.LedgerID);

      const adj = new DataArLedgerItemProcedureAdjustments();
      adj.Amount = a.Amount;
      adj.debitCredit = 'debit';
      adj.Date = a.PostDate;
      adj.PatientId = a.PatientId;
      adj.LedgerID = a.LedgerID;
      adj.enumARLedgerItemOriginTypeID = a.enumARLedgerItemOriginTypeID;
      adj.PaymentSource = 'Debit Adjustment';
      adj.PaymentDistributionTypeName = (a.Description || '').replace(/^VOID - /, '');
      adj.PaymentDistributionStatus = a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void ? this.enumARDistribItemStatusVoid : '';

      if (a.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeInsurance) {
        this.adjustmentsInsurance.push(adj);
      }
      else {
        this.adjustmentsPatient.push(adj);
      }
    });
  }

  returnProperName(PaymentDistributionTypeName: string) {
    if (PaymentDistributionTypeName) { PaymentDistributionTypeName = PaymentDistributionTypeName.toUpperCase(); }
    if (PaymentDistributionTypeName === 'STANDARD') {
      return 'Payment';
    }
  }

  getPaymentDistributionsList() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentDistributionsForLedgerTransaction(this.ledgerItem.ARTransactionItemID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  close() {
    this.dialogRef.close();
  }

  createMessage(message: string, type: string) {
    this.uiService.displayMessage(type, message);
  }

  returnPaymentType(id: string) {
    if (EnumARPaymentType.Check === id) { return 'Check'; }
    else if (EnumARPaymentType.Cash === id) { return 'Cash'; }
    else if (EnumARPaymentType.CreditCard === id) { return 'Credit Card'; }
    else if (EnumARPaymentType.CreditCardOffline === id) { return 'Credit Card Offline'; }
    else { return ''; }
  }

  openPaymentDetails(item: DataArLedgerItemProcedureAdjustments): void {
    if (!item?.PaymetnID) { return; }
    const paymentLedgerItem = this.allLedgerItems.find(a => a.PaymetnID === item.PaymetnID && a.enumARPayementTypeID !== null);
    this.dialog.open(ArPaymentDetailsComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        PaymentID: item.PaymetnID,        
        ledgerItem: paymentLedgerItem,
        patientId: this.ledgerItem.PatientId
      }
    });
  }

  isVoidedDistribution(item: DataArLedgerItemProcedureAdjustments) {
    if (item.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
      return true;
    }
    else {
      return false;
    }
  }

  getInsuranceDisplayText(): string {
    if (!this.ledgerItem?.dataARTransactionItemList) {
      return '';
    }

    const transactionItem = this.ledgerItem.dataARTransactionItemList;
    
    // Get insurance company name
    if (transactionItem.PatientInsuranceName) {
      return transactionItem.PatientInsuranceName;
    }

    return '';
  }

  changeInsurance(): void {
    const dialogRef = this.dialog.open(InsuranceChangeDialogComponent, {
      panelClass: 'dialog',
      disableClose: true,
      autoFocus: false,
      data: {
        patientId: this.globals.currentPatientId,
        currentInsurance: this.ledgerItem?.dataARTransactionItemList?.PatientInsuranceName,
        currentInsuranceId: this.ledgerItem?.dataARTransactionItemList?.PatientInsuranceID,
        arTransactionItemId: this.ledgerItem?.dataARTransactionItemList?.ARTransactionItemID
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save' && result.success) {
        // console.log('Insurance successfully changed:', result);
        
        // Update the local data to reflect the change
        if (this.ledgerItem?.dataARTransactionItemList) {
          this.ledgerItem.dataARTransactionItemList.PatientInsuranceName = result.selectedInsurance.Description;
          this.ledgerItem.dataARTransactionItemList.PatientInsuranceID = result.selectedInsurance.PatientInsuranceID;
        }
        
        // Show success message with details
        const updatedCount = result.result?.UpdatedItemsCount ?? 0;
        const message = `Insurance updated successfully. ${updatedCount} item(s) updated.`;
        this.createMessage(message, 'Success');
        this.cdr.detectChanges();
      }
    });
  }

  isChargeFeeItem(): boolean {
    return this.ledgerItem?.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit;
  }

  hasLinkedClaim(): boolean {
    // Check if there's an ARClaimID (regardless of status)
    if (this.ledgerItem?.ARClaimID) {
      return true;
    }

    // Check if the transaction item has claim flags set
    const transactionItem = this.ledgerItem?.dataARTransactionItemList;
    if (transactionItem?.hasSecondaryClaim || transactionItem?.isPrimaryClaim) {
      return true;
    }

    // Check if there are claims in the dataARClaims array
    if (transactionItem?.dataARClaims && transactionItem.dataARClaims.length > 0) {
      return true;
    }

    return false;
  }
}
